import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

class ApiKeyService {
  private static _instance: ApiKeyService;
  private _openAiApiKey: string | null = null;
  private _googleCloudApiKey: string | null = null;
  private _isInitialized: boolean = false;

  private constructor() {}

  public static getInstance(): ApiKeyService {
    if (!ApiKeyService._instance) {
      ApiKeyService._instance = new ApiKeyService();
    }
    return ApiKeyService._instance;
  }

  // API 키 getter
  public get openAiApiKey(): string | null {
    return this._openAiApiKey;
  }

  public get googleCloudApiKey(): string | null {
    return this._googleCloudApiKey;
  }

  public get isInitialized(): boolean {
    return this._isInitialized;
  }

  /**
   * 앱 시작 시 파이어베이스에서 API 키를 가져와서 저장
   */
  public async initializeApiKeys(): Promise<void> {
    try {
      console.log('API 키 초기화 시작');
      
      // admins 컬렉션에서 duri22@icloud.com 문서의 apiKey 필드 가져오기
      const adminDocRef = doc(db, 'admins', 'durii22@icloud.com');
      const adminDoc = await getDoc(adminDocRef);

      if (adminDoc.exists()) {
        const data = adminDoc.data();
        
        // OpenAI API 키
        if (data['openAiApiKey']) {
          this._openAiApiKey = data['openAiApiKey'] as string;
          console.log(`OpenAI API 키 로드 완료 (길이: ${this._openAiApiKey.length})`);
        } else {
          console.warn('OpenAI API 키가 파이어베이스에 없습니다');
        }

        // Google Cloud API 키
        if (data['googleCloudApiKey']) {
          this._googleCloudApiKey = data['googleCloudApiKey'] as string;
          console.log(`Google Cloud API 키 로드 완료 (길이: ${this._googleCloudApiKey.length})`);
        } else {
          console.warn('Google Cloud API 키가 파이어베이스에 없습니다');
        }

        // API 키 상태 로깅
        if (this._openAiApiKey && this._googleCloudApiKey) {
          console.log('모든 API 키가 성공적으로 로드되었습니다');
          this._isInitialized = true;
        } else {
          console.warn(`일부 API 키가 로드되지 않았습니다. OpenAI: ${!!this._openAiApiKey}, Google: ${!!this._googleCloudApiKey}`);
          // OpenAI 키만 있어도 초기화 완료로 간주
          if (this._openAiApiKey) {
            this._isInitialized = true;
          }
        }
      } else {
        console.error('admin 문서를 찾을 수 없습니다: duri22@icloud.com');
        throw new Error('Firebase에서 admin 문서를 찾을 수 없습니다');
      }
    } catch (error) {
      console.error('API 키 초기화 실패:', error);
      throw error;
    }
  }

  /**
   * API 키 재로드
   */
  public async reloadApiKeys(): Promise<void> {
    this._isInitialized = false;
    this._openAiApiKey = null;
    this._googleCloudApiKey = null;
    await this.initializeApiKeys();
  }

  /**
   * API 키가 유효한지 확인
   */
  public isApiKeyValid(): boolean {
    return this._isInitialized && !!this._openAiApiKey;
  }
}

export default ApiKeyService;
